// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__27lHa","tips":"styles_tips__3qtoB"};